



	// @ts-ignore
    import _ from './MContentsTitle.ts'; export default _;
